import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { SupplierInvoiceSearch } from './supplier-invoice-search.DTO';
import { tap, catchError } from 'rxjs/operators';
import { ErrorResponse } from '../config/common';
import { SUCCESS } from 'src/@shared/constants';

@Injectable()
export class SupplierInvoiceSearchService {

    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) { }
    
    // LAY TAT CA CAC SUPPLIER INVOICE SEARCH
    public GetSupplierInvoiceSearch(model: SupplierInvoiceSearch){
        this._spinner.show();
        return this._http.post(`${API.SUPPLIER_INVOICE_SEARCH.GET}`, model)
            .pipe(
                tap(() => {
                    this._spinner.hide();
                    // this._toastr.success(SUCCESS.SUPPLIER_INVOICE_SEARCH);
                }),
                catchError((err: ErrorResponse) => {
                    this._spinner.hide();
                    this._toastr.errors(err.error.errors)
                    throw err;
                }),
            );
    }
}